<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Description"
                v-model="selectedLuConcern.Description"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedLuConcern.IsActive"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveLuConcernDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuConcern from '@classes/LuConcern'
//templateTODO: import lookup components you plan to use
export default {
  components: {},
  data: () => ({
    dialog: false,
    valid: true,
    selectedLuConcern: new LuConcern(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('luConcern', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('luConcern', ['saveLuConcern']),
    async validate() {
      this.$refs.form.validate()
    },
    editLuConcern(entry) {
      this.selectedLuConcern = new LuConcern(entry)
      this.modalText = 'Edit Concern'
      this.dialog = !this.dialog
    },
    addLuConcern() {
      this.modalText = 'Insert Concern'
      this.selectedLuConcern = new LuConcern()
      this.dialog = !this.dialog
    },
    saveLuConcernDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveLuConcern(this.selectedLuConcern.removeRelated()).then(
            (res) => {
              this.$emit('refresh')
              this.selectedLuConcern = new LuConcern()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedLuConcern = new LuConcern()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
